export const superadmin_options = {
  status: {
    fieldPath: 'status',
    fieldReadPath: 'status',
    name: 'status',
    label: 'core.status.label',
    options: [
      {
        text: 'global.fields.status.active.label',
        value: 'active',
      },
      {
        text: 'global.fields.status.inactive.label',
        value: 'inactive',
      },
    ],
    veeValidation: true,
    rules: ['required'],
    warningRules: [],
    fieldClass: 'core__status--input',
    errorClass: 'core__status--input-error',
    helpClass: 'core__status--input-help',
    help: 'core.status.help',
    feedbackClass: 'core__status--input-feedback',
    feedback: 'core.status.feedback',
    labelClass: 'core__status--input-label',
  },
  name: {
    fieldPath: 'name',
    fieldReadPath: 'name',
    name: 'name',
    label: 'core.name.label',
    options: [],
    veeValidation: true,
    rules: ['required'],
    warningRules: [],
    fieldClass: 'core__name--input',
    errorClass: 'core__name--input-error',
    helpClass: 'core__name--input-help',
    help: 'core.name.help',
    feedbackClass: 'core__name--input-feedback',
    feedback: 'core.name.feedback',
    labelClass: 'core__name--input-label',
  },
  alias: {
    fieldPath: 'alias',
    fieldReadPath: 'alias',
    name: 'alias',
    label: 'core.alias.label',
    options: [],
    veeValidation: true,
    rules: ['required'],
    warningRules: [],
    fieldClass: 'core__alias--input',
    errorClass: 'core__alias--input-error',
    helpClass: 'core__alias--input-help',
    help: 'core.alias.help',
    feedbackClass: 'core__alias--input-feedback',
    feedback: 'core.alias.feedback',
    labelClass: 'core__alias--input-label',
  },
  domain: {
    fieldPath: 'domain',
    fieldReadPath: 'domain',
    name: 'domain',
    label: 'core.domain.label',
    options: [],
    veeValidation: true,
    rules: ['required'],
    warningRules: [],
    fieldClass: 'core__domain--input',
    errorClass: 'core__domain--input-error',
    helpClass: 'core__domain--input-help',
    help: 'core.domain.help',
    feedbackClass: 'core__domain--input-feedback',
    feedback: 'core.domain.feedback',
    labelClass: 'core__domain--input-label',
  },
  description: {
    fieldPath: 'description',
    fieldReadPath: 'description',
    name: 'description',
    label: 'core.description.label',
    options: [],
    veeValidation: true,
    rules: [],
    warningRules: [],
    fieldClass: 'core__description--input',
    errorClass: 'core__description--input-error',
    helpClass: 'core__description--input-help',
    help: 'core.description.help',
    feedbackClass: 'core__description--input-feedback',
    feedback: 'core.description.feedback',
    labelClass: 'core__description--input-label',
  },
  created_at: {
    fieldPath: 'created_at',
    fieldReadPath: 'created_at',
    name: 'created_at',
    label: 'core.created_at.label',
    options: [],
    veeValidation: true,
    rules: [],
    warningRules: [],
    fieldClass: 'core__created-at--input',
    errorClass: 'core__created-at--input-error',
    helpClass: 'core__created-at--input-help',
    help: 'core.created_at.help',
    feedbackClass: 'core__created-at--input-feedback',
    feedback: 'core.created_at.feedback',
    labelClass: 'core__created-at--input-label',
  },
  conditional_pricing_activated: {
    fieldPath: 'modules.conditional_pricing_activated',
    fieldReadPath: 'modules.conditional_pricing_activated',
    name: 'conditional_pricing_activated',
    label: 'core.modules.conditional_pricing_activated.label',
    options: [],
    veeValidation: true,
    rules: [],
    warningRules: [],
    fieldClass: 'core__modules-conditional-pricing-activated--input',
    errorClass: 'core__modules-conditional-pricing-activated--input-error',
    helpClass: 'core__modules-conditional-pricing-activated--input-help',
    help: 'core.modules.conditional_pricing_activated.help',
    feedbackClass: 'core__modules-conditional-pricing-activated--input-feedback',
    feedback: 'core.modules.conditional_pricing_activated.feedback',
    labelClass: 'core__modules-conditional-pricing-activated--input-label',
  },
  accounting_activated: {
    fieldPath: 'modules.accounting_activated',
    fieldReadPath: 'modules.accounting_activated',
    name: 'accounting_activated',
    label: 'core.modules.accounting_activated.label',
    options: [],
    veeValidation: true,
    rules: [],
    warningRules: [],
    fieldClass: 'core__modules-accounting-activated--input',
    errorClass: 'core__modules-accounting-activated--input-error',
    helpClass: 'core__modules-accounting-activated--input-help',
    help: 'core.modules.accounting_activated.help',
    feedbackClass: 'core__modules-accounting-activated--input-feedback',
    feedback: 'core.modules.accounting_activated.feedback',
    labelClass: 'core__modules-accounting-activated--input-label',
  },
  activities_activated: {
    fieldPath: 'modules.activities_activated',
    fieldReadPath: 'modules.activities_activated',
    name: 'activities_activated',
    label: 'core.modules.activities_activated.label',
    options: [],
    veeValidation: true,
    rules: [],
    warningRules: [],
    fieldClass: 'core__modules-activities-activated--input',
    errorClass: 'core__modules-activities-activated--input-error',
    helpClass: 'core__modules-activities-activated--input-help',
    help: 'core.modules.activities_activated.help',
    feedbackClass: 'core__modules-activities-activated--input-feedback',
    feedback: 'core.modules.activities_activated.feedback',
    labelClass: 'core__modules-activities-activated--input-label',
  },
  subscriptions_activated: {
    fieldPath: 'modules.subscriptions_activated',
    fieldReadPath: 'modules.subscriptions_activated',
    name: 'subscriptions_activated',
    label: 'core.modules.subscriptions_activated.label',
    options: [],
    veeValidation: true,
    rules: [],
    warningRules: [],
    fieldClass: 'core__modules-subscriptions-activated--input',
    errorClass: 'core__modules-subscriptions-activated--input-error',
    helpClass: 'core__modules-subscriptions-activated--input-help',
    help: 'core.modules.subscriptions_activated.help',
    feedbackClass: 'core__modules-subscriptions-activated--input-feedback',
    feedback: 'core.modules.subscriptions_activated.feedback',
    labelClass: 'core__modules-subscriptions-activated--input-label',
  },
  contracts_documents_activated: {
    fieldPath: 'modules.contracts_documents_activated',
    fieldReadPath: 'modules.contracts_documents_activated',
    name: 'contracts_documents_activated',
    label: 'core.modules.contracts_documents_activated.label',
    options: [],
    veeValidation: true,
    rules: [],
    warningRules: [],
    fieldClass: 'core__modules-contracts-documents-activated--input',
    errorClass: 'core__modules-contracts-documents-activated--input-error',
    helpClass: 'core__modules-contracts-documents-activated--input-help',
    help: 'core.modules.contracts_documents_activated.help',
    feedbackClass: 'core__modules-contracts-documents-activated--input-feedback',
    feedback: 'core.modules.contracts_documents_activated.feedback',
    labelClass: 'core__modules-contracts-documents-activated--input-label',
  },
  communications_activated: {
    fieldPath: 'modules.communications_activated',
    fieldReadPath: 'modules.communications_activated',
    name: 'communications_activated',
    label: 'core.modules.communications_activated.label',
    options: [],
    veeValidation: true,
    rules: [],
    warningRules: [],
    fieldClass: 'core__modules-communications-activated--input',
    errorClass: 'core__modules-communications-activated--input-error',
    helpClass: 'core__modules-communications-activated--input-help',
    help: 'core.modules.communications_activated.help',
    feedbackClass: 'core__modules-communications-activated--input-feedback',
    feedback: 'core.modules.communications_activated.feedback',
    labelClass: 'core__modules-communications-activated--input-label',
  },
  tax_management_activated: {
    fieldPath: 'modules.tax_management_activated',
    fieldReadPath: 'modules.tax_management_activated',
    name: 'tax_management_activated',
    label: 'core.modules.tax_management_activated.label',
    options: [],
    veeValidation: true,
    rules: [],
    warningRules: [],
    fieldClass: 'core__modules-tax-management-activated--input',
    errorClass: 'core__modules-tax-management-activated--input-error',
    helpClass: 'core__modules-tax-management-activated--input-help',
    help: 'core.modules.tax_management_activated.help',
    feedbackClass: 'core__modules-tax-management-activated--input-feedback',
    feedback: 'core.modules.tax_management_activated.feedback',
    labelClass: 'core__modules-tax-management-activated--input-label',
  },
  bookings_activated: {
    fieldPath: 'modules.bookings_activated',
    fieldReadPath: 'modules.bookings_activated',
    name: 'bookings_activated',
    label: 'core.modules.bookings_activated.label',
    options: [],
    veeValidation: true,
    rules: [],
    warningRules: [],
    fieldClass: 'core__modules-bookings-activated--input',
    errorClass: 'core__modules-bookings-activated--input-error',
    helpClass: 'core__modules-bookings-activated--input-help',
    help: 'core.modules.bookings_activated.help',
    feedbackClass: 'core__modules-bookings-activated--input-feedback',
    feedback: 'core.modules.bookings_activated.feedback',
    labelClass: 'core__modules-bookings-activated--input-label',
  },
  contacts_activated: {
    fieldPath: 'modules.contacts_activated',
    fieldReadPath: 'modules.contacts_activated',
    name: 'contacts_activated',
    label: 'core.modules.contacts_activated.label',
    options: [],
    veeValidation: true,
    rules: [],
    warningRules: [],
    fieldClass: 'core__modules-contacts-activated--input',
    errorClass: 'core__modules-contacts-activated--input-error',
    helpClass: 'core__modules-contacts-activated--input-help',
    help: 'core.modules.contacts_activated.help',
    feedbackClass: 'core__modules-contacts-activated--input-feedback',
    feedback: 'core.modules.contacts_activated.feedback',
    labelClass: 'core__modules-contacts-activated--input-label',
  },
  cms_activated: {
    fieldPath: 'modules.cms_activated',
    fieldReadPath: 'modules.cms_activated',
    name: 'cms_activated',
    label: 'core.modules.cms_activated.label',
    options: [],
    veeValidation: true,
    rules: [],
    warningRules: [],
    fieldClass: 'core__modules-cms-activated--input',
    errorClass: 'core__modules-cms-activated--input-error',
    helpClass: 'core__modules-cms-activated--input-help',
    help: 'core.modules.cms_activated.help',
    feedbackClass: 'core__modules-cms-activated--input-feedback',
    feedback: 'core.modules.cms_activated.feedback',
    labelClass: 'core__modules-cms-activated--input-label',
  },
  certificates_activated: {
    fieldPath: 'modules.certificates_activated',
    fieldReadPath: 'modules.certificates_activated',
    name: 'certificates_activated',
    label: 'core.modules.certificates_activated.label',
    options: [],
    veeValidation: true,
    rules: [],
    warningRules: [],
    fieldClass: 'core__modules-certificates-activated--input',
    errorClass: 'core__modules-certificates-activated--input-error',
    helpClass: 'core__modules-certificates-activated--input-help',
    help: 'core.modules.certificates_activated.help',
    feedbackClass: 'core__modules-certificates-activated--input-feedback',
    feedback: 'core.modules.certificates_activated.feedback',
    labelClass: 'core__modules-certificates-activated--input-label',
  },
  point_of_sale_activated: {
    fieldPath: 'modules.point_of_sale_activated',
    fieldReadPath: 'modules.point_of_sale_activated',
    name: 'point_of_sale_activated',
    label: 'core.modules.point_of_sale_activated.label',
    options: [],
    veeValidation: true,
    rules: [],
    warningRules: [],
    fieldClass: 'core__modules-point-of-sale-activated--input',
    errorClass: 'core__modules-point-of-sale-activated--input-error',
    helpClass: 'core__modules-point-of-sale-activated--input-help',
    help: 'core.modules.point_of_sale_activated.help',
    feedbackClass: 'core__modules-point-of-sale-activated--input-feedback',
    feedback: 'core.modules.point_of_sale_activated.feedback',
    labelClass: 'core__modules-point-of-sale-activated--input-label',
  },
  payment_terminals_activated: {
    fieldPath: 'modules.payment_terminals_activated',
    fieldReadPath: 'modules.payment_terminals_activated',
    name: 'payment_terminals_activated',
    label: 'core.modules.payment_terminals_activated.label',
    options: [],
    veeValidation: true,
    rules: [],
    warningRules: [],
    fieldClass: 'core__modules-payment-terminals-activated--input',
    errorClass: 'core__modules-payment-terminals-activated--input-error',
    helpClass: 'core__modules-payment-terminals-activated--input-help',
    help: 'core.modules.payment_terminals_activated.help',
    feedbackClass: 'core__modules-payment-terminals-activated--input-feedback',
    feedback: 'core.modules.payment_terminals_activated.feedback',
    labelClass: 'core__modules-payment-terminals-activated--input-label',
  },
  accounting_integrations_activated: {
    fieldPath: 'modules.accounting_integrations_activated',
    fieldReadPath: 'modules.accounting_integrations_activated',
    name: 'accounting_integrations_activated',
    label: 'core.modules.accounting_integrations_activated.label',
    options: [],
    veeValidation: true,
    rules: [],
    warningRules: [],
    fieldClass: 'core__modules-accounting-integrations-activated--input',
    errorClass: 'core__modules-accounting-integrations-activated--input-error',
    helpClass: 'core__modules-accounting-integrations-activated--input-help',
    help: 'core.modules.accounting_integrations_activated.help',
    feedbackClass: 'core__modules-accounting-integrations-activated--input-feedback',
    feedback: 'core.modules.accounting_integrations_activated.feedback',
    labelClass: 'core__modules-accounting-integrations-activated--input-label',
  },
  entries_activated: {
    fieldPath: 'modules.entries_activated',
    fieldReadPath: 'modules.entries_activated',
    name: 'entries_activated',
    label: 'core.modules.entries_activated.label',
    options: [],
    veeValidation: true,
    rules: [],
    warningRules: [],
    fieldClass: 'core__modules-entries-activated--input',
    errorClass: 'core__modules-entries-activated--input-error',
    helpClass: 'core__modules-entries-activated--input-help',
    help: 'core.modules.entries_activated.help',
    feedbackClass: 'core__modules-entries-activated--input-feedback',
    feedback: 'core.modules.entries_activated.feedback',
    labelClass: 'core__modules-entries-activated--input-label',
  },
  subventions_activated: {
    fieldPath: 'modules.subventions_activated',
    fieldReadPath: 'modules.subventions_activated',
    name: 'subventions_activated',
    label: 'core.modules.subventions_activated.label',
    options: [],
    veeValidation: true,
    rules: [],
    warningRules: [],
    fieldClass: 'core__modules-subventions-activated--input',
    errorClass: 'core__modules-subventions-activated--input-error',
    helpClass: 'core__modules-subventions-activated--input-help',
    help: 'core.modules.subventions_activated.help',
    feedbackClass: 'core__modules-subventions-activated--input-feedback',
    feedback: 'core.modules.subventions_activated.feedback',
    labelClass: 'core__modules-subventions-activated--input-label',
  },
  center_type: {
    fieldPath: 'center_type',
    fieldReadPath: 'center_type',
    name: 'center_type',
    label: 'core.center_type.label',
    options: [
      {
        text: 'global.center_type.center',
        value: 'center',
      },
      {
        text: 'global.center_type.league',
        value: 'league',
      },
      {
        text: 'global.center_type.club',
        value: 'club',
      },
    ],
    veeValidation: true,
    rules: ['required'],
    warningRules: [],
    fieldClass: 'core__center-type--input',
    errorClass: 'core__center-type--input-error',
    helpClass: 'core__center-type--input-help',
    help: 'core.center_type.help',
    feedbackClass: 'core__center-type--input-feedback',
    feedback: 'core.center_type.feedback',
    labelClass: 'core__center-type--input-label',
  },
  public_css: {
    fieldPath: 'public_css',
    fieldReadPath: 'public_css',
    name: 'public_css',
    label: 'core.public_css.label',
    options: [],
    veeValidation: true,
    rules: [],
    warningRules: [],
    fieldClass: 'core__public-css--input',
    errorClass: 'core__public-css--input-error',
    helpClass: 'core__public-css--input-help',
    help: 'core.public_css.help',
    feedbackClass: 'core__public-css--input-feedback',
    feedback: 'core.public_css.feedback',
    labelClass: 'core__public-css--input-label',
  },
  admin_css: {
    fieldPath: 'admin_css',
    fieldReadPath: 'admin_css',
    name: 'admin_css',
    label: 'core.admin_css.label',
    options: [],
    veeValidation: true,
    rules: [],
    warningRules: [],
    fieldClass: 'core__admin-css--input',
    errorClass: 'core__admin-css--input-error',
    helpClass: 'core__admin-css--input-help',
    help: 'core.admin_css.help',
    feedbackClass: 'core__admin-css--input-feedback',
    feedback: 'core.admin_css.feedback',
    labelClass: 'core__admin-css--input-label',
  },
  stylesheet: {
    fieldPath: 'stylesheet',
    fieldReadPath: 'stylesheet',
    name: 'stylesheet',
    label: 'core.stylesheet.label',
    options: [],
    veeValidation: true,
    rules: [],
    warningRules: [],
    fieldClass: 'core__stylesheet--input',
    errorClass: 'core__stylesheet--input-error',
    helpClass: 'core__stylesheet--input-help',
    help: 'core.stylesheet.help',
    feedbackClass: 'core__stylesheet--input-feedback',
    feedback: 'core.stylesheet.feedback',
    labelClass: 'core__stylesheet--input-label',
  },
  use_new_cms: {
    fieldPath: 'use_new_cms',
    fieldReadPath: 'use_new_cms',
    name: 'use_new_cms',
    label: 'core.use_new_cms.label',
    options: [],
    veeValidation: true,
    rules: [],
    warningRules: [],
    fieldClass: 'core__use-new-cms--input',
    errorClass: 'core__use-new-cms--input-error',
    helpClass: 'core__use-new-cms--input-help',
    help: 'core.use-new-cms.help',
    feedbackClass: 'core__use-new-cms--input-feedback',
    feedback: 'core.use-new-cms.feedback',
    labelClass: 'core__use-new-cms--input-label',
  },
  free_bookings_activated: {
    fieldPath: 'free_bookings_activated',
    fieldReadPath: 'free_bookings_activated',
    name: 'free_bookings_activated',
    label: 'core.free_bookings_activated.label',
    options: [],
    veeValidation: true,
    rules: [],
    warningRules: [],
    fieldClass: 'core__free-bookings-activated--input',
    errorClass: 'core__free-bookings-activated--input-error',
    helpClass: 'core__free-bookings-activated--input-help',
    help: 'core.free-bookings-activated.help',
    feedbackClass: 'core__free-bookings-activated--input-feedback',
    feedback: 'core.free-bookings-activated.feedback',
    labelClass: 'core__free-bookings-activated--input-label',
  },
  access_control_activated: {
    fieldPath: 'modules.access_control_activated',
    fieldReadPath: 'modules.access_control_activated',
    name: 'access_control_activated',
    label: 'core.modules.access_control_activated.label',
    options: [],
    veeValidation: true,
    rules: [],
    warningRules: [],
    fieldClass: 'core__modules-access-control-activated--input',
    errorClass: 'core__modules-access-control-activated--input-error',
    helpClass: 'core__modules-access-control-activated--input-help',
    help: 'core.modules.access_control_activated.help',
    feedbackClass: 'core__modules-access-control-activated--input-feedback',
    feedback: 'core.modules.access_control_activated.feedback',
    labelClass: 'core__modules-access-control-activated--input-label',
  },
  coda_management_activated: {
    fieldPath: 'modules.coda_management_activated',
    fieldReadPath: 'modules.coda_management_activated',
    name: 'coda_management_activated',
    label: 'core.modules.coda_management_activated.label',
    options: [],
    veeValidation: true,
    rules: [],
    warningRules: [],
    fieldClass: 'core__modules-coda-management-activated--input',
    errorClass: 'core__modules-coda-management-activated--input-error',
    helpClass: 'core__modules-coda-management-activated--input-help',
    help: 'core.modules.coda_management_activated.help',
    feedbackClass: 'core__modules-coda-management-activated--input-feedback',
    feedback: 'core.modules.coda_management_activated.feedback',
    labelClass: 'core__modules-coda-management-activated--input-label',
  },
  tax_certificates_activated: {
    fieldPath: 'modules.tax_certificates_activated',
    fieldReadPath: 'modules.tax_certificates_activated',
    name: 'tax_certificates_activated',
    label: 'core.modules.tax_certificates_activated.label',
    options: [],
    veeValidation: true,
    rules: [],
    warningRules: [],
    fieldClass: 'core__modules-tax-certificates-activated--input',
    errorClass: 'core__modules-tax-certificates-activated--input-error',
    helpClass: 'core__modules-tax-certificates-activated--input-help',
    help: 'core.modules.tax_certificates_activated.help',
    feedbackClass: 'core__modules-tax-certificates-activated--input-feedback',
    feedback: 'core.modules.tax_certificates_activated.feedback',
    labelClass: 'core__modules-tax-certificates-activated--input-label',
  },
  anybuddy_activated: {
    fieldPath: 'modules.anybuddy_activated',
    fieldReadPath: 'modules.anybuddy_activated',
    name: 'anybuddy_activated',
    label: 'core.modules.anybuddy_activated.label',
    options: [],
    veeValidation: true,
    rules: [],
    warningRules: [],
    fieldClass: 'core__modules-enable-anybuddy--input',
    errorClass: 'core__modules-enable-anybuddy--input-error',
    helpClass: 'core__modules-enable-anybuddy--input-help',
    help: 'core.modules.anybuddy_activated.help',
    feedbackClass: 'core__modules-enable-anybuddy--input-feedback',
    feedback: 'core.modules.anybuddy_activated.feedback',
    labelClass: 'core__modules-enable-anybuddy--input-label',
  },
  tppwb_sync_activated: {
    fieldPath: 'modules.tppwb_sync_activated',
    fieldReadPath: 'modules.tppwb_sync_activated',
    name: 'tppwb_sync_activated',
    label: 'core.modules.tppwb_sync_activated.label',
    options: [],
    veeValidation: true,
    rules: [],
    warningRules: [],
    fieldClass: 'core__modules-tppwb-sync-activated--input',
    errorClass: 'core__modules-tppwb_sync_activated--input-error',
    helpClass: 'core__modules-tppwb_sync_activated--input-help',
    help: 'core.modules.tppwb_sync_activated.help',
    feedbackClass: 'core__modules-tppwb_sync_activated--input-feedback',
    feedback: 'core.modules.tppwb_sync_activated.feedback',
    labelClass: 'core__modules-tppwb_sync_activated--input-label',
  },
  virtual_wallet_activated: {
    fieldPath: 'modules.virtual_wallet_activated',
    fieldReadPath: 'modules.virtual_wallet_activated',
    name: 'virtual_wallet_activated',
    label: 'core.modules.virtual_wallet_activated.label',
    options: [],
    veeValidation: true,
    rules: [],
    warningRules: [],
    fieldClass: 'core__modules-virtual-wallet-activated--input',
    errorClass: 'core__modules-virtual-wallet-activated--input-error',
    helpClass: 'core__modules-virtual-wallet-activated--input-help',
    help: 'core.modules.virtual_wallet_activated.help',
    feedbackClass: 'core__modules-virtual-wallet-activated--input-feedback',
    feedback: 'core.modules.virtual_wallet_activated.feedback',
    labelClass: 'core__modules-virtual-wallet-activated--input-label',
  },
  online_booking_v2_activated: {
    fieldPath: 'modules.online_booking_v2_activated',
    fieldReadPath: 'modules.online_booking_v2_activated',
    name: 'online_booking_v2_activated',
    label: 'core.online_booking_v2_activated.label',
    options: [],
    veeValidation: true,
    rules: [],
    warningRules: [],
    fieldClass: 'core__online-booking-v2-activated--input',
    errorClass: 'core__online-booking-v2-activated--input-error',
    helpClass: 'core__online-booking-v2-activated--input-help',
    help: 'core.online_booking_v2_activated.help',
    feedbackClass: 'core__online-booking-v2-activated--input-feedback',
    feedback: 'core.online_booking_v2_activated.feedback',
    labelClass: 'core__online-booking-v2-activated--input-label',
    hideInModuleList: true,
  },
  frontoffice_v2_activated: {
    fieldPath: 'modules.frontoffice_v2_activated',
    fieldReadPath: 'modules.frontoffice_v2_activated',
    name: 'frontoffice_v2_activated',
    label: 'core.frontoffice_v2_activated.label',
    options: [],
    veeValidation: true,
    rules: [],
    warningRules: [],
    fieldClass: 'core__frontoffice-v2-activated--input',
    errorClass: 'core__frontoffice-v2-activated--input-error',
    helpClass: 'core__frontoffice-v2-activated--input-help',
    help: 'core.frontoffice_v2_activated.help',
    feedbackClass: 'core__frontoffice-v2-activated--input-feedback',
    feedback: 'core.frontoffice_v2_activated.feedback',
    labelClass: 'core__frontoffice-v2-activated--input-label',
    hideInModuleList: true,
  },
  enable_contact_card: {
    fieldPath: 'enable_contact_card',
    fieldReadPath: 'enable_contact_card',
    name: 'enable_contact_card',
    label: 'core.enable_contact_card.label',
    options: [],
    veeValidation: true,
    rules: [],
    warningRules: [],
    fieldClass: 'core__enable-contact-card--input',
    errorClass: 'core__enable-contact-card--input--input-error',
    helpClass: 'core__enable-contact-card--input--input-help',
    help: 'core.enable_contact_card.help',
    feedbackClass: 'core__enable-contact-card--input-feedback',
    feedback: 'core.enable_contact_card_activated.feedback',
    labelClass: 'core__enable-contact-card--input-label',
  },
  contact_card_layout: {
    fieldPath: 'contact_card_layout',
    fieldReadPath: 'contact_card_layout',
    name: 'contact_card_layout',
    label: 'core.contact_card_layout.label',
    defaultValue: 'contact_card_with_fullname_and_picture',
    options: [
      {
        text: 'global.center.contact_card_with_fullname_and_picture',
        value: 'contact_card_with_fullname_and_picture',
      },
      {
        text: 'global.center.contact_card_with_fullname.label',
        value: 'contact_card_with_fullname',
      },
    ],
    veeValidation: true,
    rules: [],
    warningRules: [],
    fieldClass: 'core__contact-card-layout--input',
    errorClass: 'core__contact-card-layout--input--input-error',
    helpClass: 'core__contact-card-layout--input--input-help',
    help: 'core.contact_card_layout.help',
    feedbackClass: 'core__contact-card-layout--input-feedback',
    feedback: 'core.contact_card_layout_activated.feedback',
    labelClass: 'core__contact-card-layout--input-label',
  },
  use_pos_v2: {
    fieldPath: 'use_pos_v2',
    fieldReadPath: 'use_pos_v2',
    name: 'use_pos_v2',
    label: 'core.use_pos_v2.label',
    options: [],
    veeValidation: true,
    rules: [],
    warningRules: [],
    fieldClass: 'core__use-pos-v2--input',
    errorClass: 'core__use-pos-v2--input-error',
    helpClass: 'core__use-pos-v2--input-help',
    help: 'core.use-pos-v2.help',
    feedbackClass: 'core__use-pos-v2--input-feedback',
    feedback: 'core.use-pos-v2.feedback',
    labelClass: 'core__use-pos-v2--input-label',
  },
  use_structured_communication: {
    fieldPath: 'use_structured_communication',
    fieldReadPath: 'use_structured_communication',
    name: 'use_structured_communication',
    label: 'core.use_structured_communication.label',
    options: [],
    veeValidation: true,
    rules: [],
    warningRules: [],
    fieldClass: 'core__use-use_structured_communication--input',
    errorClass: 'core__use-use_structured_communication--input-error',
    helpClass: 'core__use-use_structured_communication--input-help',
    help: 'core.use-use_structured_communication.help',
    feedbackClass: 'core__use_structured_communication--input-feedback',
    feedback: 'core.use_structured_communication.feedback',
    labelClass: 'core__use_structured_communication--input-label',
  },
  strict_accounting: {
    fieldPath: 'strict_accounting',
    fieldReadPath: 'strict_accounting',
    name: 'strict_accounting',
    label: 'global.strict_accounting.label',
    options: [],
    veeValidation: true,
    rules: [],
    warningRules: [],
    fieldClass: 'core__strict_accounting--input',
    errorClass: 'core__strict_accounting--input-error',
    helpClass: 'core__strict_accounting--input-help',
    help: 'core.strict_accounting.help',
    feedbackClass: 'core__strict_accounting--input-feedback',
    feedback: 'core.strict_accounting.feedback',
    labelClass: 'core__strict_accounting--input-label',
  },
  use_article_impacts: {
    fieldPath: 'use_article_impacts',
    fieldReadPath: 'use_article_impacts',
    name: 'use_article_impacts',
    label: 'core.use_article_impacts.label',
    options: [],
    veeValidation: true,
    rules: [],
    warningRules: [],
    fieldClass: 'core__use-use_article_impacts--input',
    errorClass: 'core__use-use_article_impacts--input-error',
    helpClass: 'core__use-use_article_impacts--input-help',
    help: 'core.use-use_article_impacts.help',
    feedbackClass: 'use_article_impacts--input-feedback',
    feedback: 'core.use_article_impacts.feedback',
    labelClass: 'use_article_impacts--input-label',
  },
  use_multiplayer_bookings: {
    fieldPath: 'use_multiplayer_bookings',
    fieldReadPath: 'use_multiplayer_bookings',
    name: 'use_multiplayer_bookings',
    label: 'core.use_multiplayer_bookings.label',
    options: [],
    veeValidation: true,
    rules: [],
    warningRules: [],
    fieldClass: 'core__use-multiplayer-bookings--input',
    errorClass: 'core__use-multiplayer-bookings--input-error',
    helpClass: 'core__use-multiplayer-bookings--input-help',
    help: 'core.use-multiplayer-bookings.help',
    feedbackClass: 'core__use-multiplayer-bookings--input-feedback',
    feedback: 'core.use-multiplayer-bookings.feedback',
    labelClass: 'core__use-multiplayer-bookings--input-label',
  },
  use_contact_relations_v2: {
    fieldPath: 'use_contact_relations_v2',
    fieldReadPath: 'use_contact_relations_v2',
    name: 'use_contact_relations_v2',
    label: 'core.use_contact_relations_v2.label',
    options: [],
    veeValidation: true,
    rules: [],
    warningRules: [],
    fieldClass: 'core__use-contact-relations-v2--input',
    errorClass: 'core__use-contact-relations-v2--input-error',
    helpClass: 'core__use-contact-relations-v2--input-help',
    help: 'core.use-contact-relations-v2.help',
    feedbackClass: 'core__use-contact-relations-v2--input-feedback',
    feedback: 'core.use-contact-relations-v2.feedback',
    labelClass: 'core__use-contact-relations-v2--input-label',
  },

  tenant_template_id: {
    fieldPath: 'tenant_template_id',
    fieldReadPath: 'tenant_template_id',
    name: 'tenant_template_id',
    label: 'core.tenant_template_id.label',
    veeValidation: true,
    rules: [],
    warningRules: [],
    fieldClass: 'core__tenant_template_id--input',
    errorClass: 'core__tenant_template_id--input-error',
    helpClass: 'core__tenant_template_id--input-help',
    help: 'core.tenant_template_id.help',
    feedbackClass: 'core__tenant_template_id--input-feedback',
    feedback: 'core.tenant_template_id.feedback',
    labelClass: 'core__tenant_template_id--input-label',
    selectLabel: 'name',
    selectValue: 'id',
  },

  contactRelationCategoryId: {
    fieldPath: 'contact_relation_category_id',
    fieldReadPath: 'contact_relation_category_id',
    name: 'contact_relation_category_id',
    label: 'contacts.contact_relations.contact_relation_category.label',
    veeValidation: true,
    rules: ['required'],
    warningRules: [],
    fieldClass: 'core__contact-relation-mapping-contact-relation-category-id--input',
    errorClass: 'core__contact-relation-mapping-contact-relation-category-id--input-error',
    helpClass: 'core__contact-relation-mapping-contact-relation-category-id--input-help',
    help: 'core.contact_relation_mapping_contact_relation_category_id.help',
    feedbackClass: 'core__contact-relation-mapping-contact_relation_category_id--input-feedback',
    feedback: 'core.contact_relation_mapping_contact_relation_category_id.feedback',
    labelClass: 'core__contact-relation-mapping-contact-relation-category-id--input-label',
  },

  typeOfRelation: {
    fieldPath: 'type',
    fieldReadPath: 'type',
    name: 'type',
    label: 'core.contact_relation_mapping_type.label',
    options: [
      {
        text: 'core.contact_relation_mapping_type.partner.label',
        value: 'partner',
      },
      {
        text: 'core.contact_relation_mapping_type.parent.label',
        value: 'parent',
      },
      {
        text: 'core.contact_relation_mapping_type.child.label',
        value: 'child',
      },
      {
        text: 'core.contact_relation_mapping_type.sibling.label',
        value: 'sibling',
      },
    ],
    veeValidation: true,
    rules: ['required'],
    warningRules: [],
    fieldClass: 'core__contact-relation-mapping-type--input',
    errorClass: 'core__contact-relation-mapping-type--input-error',
    helpClass: 'core__contact-relation-mapping-type--input-help',
    help: 'core.contact_relation_mapping_type.help',
    feedbackClass: 'core__contact-relation-mapping-type--input-feedback',
    feedback: 'core.contact_relation_mapping_type.feedback',
    labelClass: 'core__contact-relation-mapping-type--input-label',
  },

  mappingStatus: {
    fieldPath: 'status',
    fieldReadPath: 'status',
    name: 'status',
    label: 'core.status.label',
    options: [
      {
        text: 'global.fields.status.done.label',
        value: 'done',
      },
      {
        text: 'global.fields.status.todo.label',
        value: 'todo',
      },
    ],
    veeValidation: true,
    warningRules: [],
    fieldClass: 'core__status--input',
    errorClass: 'core__status--input-error',
    helpClass: 'core__status--input-help',
    help: 'core.status.help',
    feedbackClass: 'core__status--input-feedback',
    feedback: 'core.status.feedback',
    labelClass: 'core__status--input-label',
  },
};
